import { render, staticRenderFns } from "./Part-Active.vue?vue&type=template&id=f68d2884"
import script from "./Part-Active.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Active.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f68d2884')) {
      api.createRecord('f68d2884', component.options)
    } else {
      api.reload('f68d2884', component.options)
    }
    module.hot.accept("./Part-Active.vue?vue&type=template&id=f68d2884", function () {
      api.rerender('f68d2884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/Part-Active.vue"
export default component.exports